import { useEffect, useRef, useState } from 'react';
import { InputV2, ButtonLoading, SimpleDialog, CustomCaptchaComponent } from 'components';

import { Grid, Button, useMediaQuery } from '@mui/material';
import { useStyles } from './style';
import createToast from 'components/Toast/Toast';
const InquiryAgentDg = (props) => {
  const classes = useStyles();
  const matches = useMediaQuery('(max-width:600px)');

  const {
    captachaAgetRef,

    isLoadingAgentDg,
    setIsLoadingOwnerDg,
    isOpenAgentDg,
    setIsOpenAgentDg,
    enteredCaptchaAgent,
    setEnteredCaptchaAgent,
    captchaIdAgentDg,
    setCaptchaIdAgentDg,

    setAgentValues,
    agentValues,
    agentFullName,

    methods,
    getBranchAgent,
  } = props;
  const [copyValues, setCopyValues] = useState(null);
  const [disableLoading, setDisableLoading] = useState(false);
  useEffect(() => {
    isOpenAgentDg && setCopyValues(JSON.stringify(agentValues));
  }, [isOpenAgentDg]);

  
  useEffect(() => {
    if (isLoadingAgentDg) {
      setTimeout(() => {
        setDisableLoading(true)
      }, 1);
    } else {
      setTimeout(() => {
        setDisableLoading(false)
      }, 200);
    }
  }, [isLoadingAgentDg]);


  const BtnActions = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={isLoadingAgentDg}
          name="استعلام"
          disabled={!enteredCaptchaAgent || !enteredCaptchaAgent.trim() || isLoadingAgentDg}
          onClick={() => {
            if (!String(agentValues?.agentNationalCode).length) {
              createToast('خطا', ' کد ملی نماینده باید 10 رقم باشد.', 'danger');
              return;
            } else {
              getBranchAgent();
            }
          }}        />

        <Button
          variant="contained"
          disabled={disableLoading}
          onClick={() => {
            setIsOpenAgentDg(false);
            setTimeout(() => {
              !agentFullName && setAgentValues({ agentCellphoneNumber: '', agentNationalCode: '' });
              agentFullName && setAgentValues(JSON.parse(copyValues));
            }, 100);
          }}>
          انصراف
        </Button>
      </>
    );
  };
  return (
    <SimpleDialog
      title={agentFullName ? 'تغییر نماینده' : 'افزودن نماینده'}
      open={isOpenAgentDg}
      actions={<BtnActions />}
    >
      <Grid direction="row" spacing={3} container item xs={12} md={12} lg={12}>
        <Grid item md={6} xs={12}>
          <InputV2
            fullWidth
            errors={methods.formState.errors}
            label="شماره همراه نماینده"
            name="cellphoneNumber"
            register={methods.register}
            control={methods.control}
            onChangeValue={(e) => {
              setAgentValues({ ...agentValues, agentCellphoneNumber: e?.target?.value });
            }}
            defaultValue={agentValues?.agentCellphoneNumber}
            dir="ltr"
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <InputV2
            fullWidth
            errors={methods.formState.errors}
            label="کد ملی نماینده"
            name="nationalCode"
            register={methods.register}
            control={methods.control}
            dir="ltr"
            onChangeValue={(e) => {
              setAgentValues({ ...agentValues, agentNationalCode: e?.target?.value });
            }}
            defaultValue={agentValues?.agentNationalCode}
          />
        </Grid>
      </Grid>

      <Grid container wrap={matches ? 'wrap' : 'nowrap'}>
        <InputV2
          label="کد امنیتی"
          forceValue={enteredCaptchaAgent}
          onChangeValue={(e) => {
            const value = e.target.value;
            if (value.length > 5) {
              e.preventDefault();
              setEnteredCaptchaAgent(value.slice(0, 5));
            } else {
              setEnteredCaptchaAgent(value);
            }
          }}
          englishNumber
          rules={['isNumeric']}
          fullWidth
          dir="ltr"
        />
        <CustomCaptchaComponent
          pageTitle="/Branch/Add - ایجاد شعبه - دیالوگ افزودن مالک"
          ref={captachaAgetRef}
          setCaptchaId={setCaptchaIdAgentDg}
          setEnteredCaptcha={setEnteredCaptchaAgent}
          sizeOptions={{ xs: '12', md: '10', lg: '10' }}
        />
      </Grid>
    </SimpleDialog>
  );
};

export default InquiryAgentDg;
